import LibraryResponse from "../../../library/near/LibraryNearResponse";
import LocationFullResponse from "../../../library/LocationFullResponse";

interface BookSearchSettingsResponse {
    librarySearchMethod: LibrarySearchMethod
    regionDetails: LocationFullResponse[]
    libraries: LibraryResponse[]
    lastLocationLat: number
    lastLocationLong: number
    isReadingSourceEnabled: boolean
    isReadingSourceMemoEnabled: boolean
}

type LibrarySearchMethod = 'CURRENT_LOCATION' | 'SPECIFIC_REGIONS' | 'SPECIFIC_LIBRARIES'

export function getLibrarySearchScope(settings: BookSearchSettingsResponse | null, locationName?: string | null): string {
    if (settings?.librarySearchMethod === 'SPECIFIC_REGIONS') {
        return settings.regionDetails.map(r => r.depth2.koreanName).join(', ')
    }
    if (settings?.librarySearchMethod === 'SPECIFIC_LIBRARIES') {
        return settings.libraries.map(l => l.name.replace(/\s*\([^)]*\)/g, '')).join(', ')
    }
    return locationName ?? '현재 위치'
}

export default BookSearchSettingsResponse